<script lang="ts">
	import JourneyListBox from '$lib/components/Box/JourneyListBox.svelte';
	import SectionInformationBlock from '$lib/components/Contentblocks/SectionInformationBlock.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import CourseTrailer from '../CourseTrailer.svelte';

	// TODO: Fix the typing here -> CourseDetail$result['course']['lessons']
	export let lessons: Array<any>;
	// If used as lesson list, this slug provides the first slug of the two slug URL
	// to navigate to the lesson.
	export let courseSlug: string;
	export let trailerThumbnail: string = '';
	export let additionalClass = '';

	// The number of initial visible entries before show more is clicked.
	const initialEntriesAmount = 6;
	const { t } = getTranslate();

	$: sectionTitle = $t('section-title.curriculum.course-detail');
	$: title = $t('title.curriculum.course-detail');
	$: description = $t('description.curriculum.course-detail');
</script>

{#if lessons && lessons.length > 0}
	<SectionInformationBlock
		additionalClass={classes(additionalClass, 'col-start-2 col-end-7')}
		additionalContentClass={'flex flex-col pt-6 lg:flex-row'}
		{sectionTitle}
		{title}
		{description}
	>
		<CourseTrailer
			additionalClass="max-w-fit -mt-10"
			showHeadline={true}
			elementId="trailer-section"
			trailerUrl={lessons?.[0]?.streamUrl || ''}
			title={lessons?.[0]?.name ?? ''}
			id={lessons?.[0]?.id ?? ''}
			overlayTitle={lessons?.[1]?.name || 'NEXT LESSON'}
			overlayHref={`${courseSlug}/${lessons[1]?.slug}` || ''}
			{trailerThumbnail}
		/>
		<JourneyListBox
			{initialEntriesAmount}
			showTitle={false}
			tolgeePrefix="curriculum"
			entries={lessons.map((lesson) => ({
				name: lesson.name,
				slug: `${courseSlug}/${lesson.slug}`
			}))}
		/>
	</SectionInformationBlock>
{/if}
